import loadable from '@loadable/component';
import { useState } from 'react';
import Skeleton from '../../components/Reusable/Skeleton';
import APIS from '../../constant/Endpoint';
import useGetHook from '../../customHooks/useGetHook';
import usePatchHook from '../../customHooks/usePatchHook';

const EditStatusComponent = loadable(
  () => import('../../components/VehicleManifest')
);

const VehicleManifestStatusEdit = () => {
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [defaultValue, setDefaultValue] = useState<any>([]);

  const handleEditStatusChange = (value: any) => {
    setDefaultValue(value);
  };

  const { data: statusList } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {
      is_active: true,
    },
  });

  const { data: gridData, isLoading } = useGetHook({
    queryKey: [`vehicle-manifest-status`],
    url: `${APIS.VEHICLE_MANIFEST_STATUS}`,
    params: {},
  });

  const { mutateAsync, isLoading: patchLoading } = usePatchHook({
    queryKey: ['vehicle-manifest-status'],
    navigateURL: '',
  });

  const handleOpenEditPopup = (item: any) => {
    setSelectedItem(item);
    setDefaultValue([...item?.status_id]);
    setOpenEditPopup(true);
  };

  const handleStatusInclude = async (event: any) => {
    event.preventDefault();
    const url = `${APIS.VEHICLE_MANIFEST_STATUS}${selectedItem?.id}/`;
    let formData = {
      status_id: defaultValue?.map((item: any) => item.id) ?? [],
    };
    try {
      const rest = await mutateAsync({ url, formData });
      if (rest.status === 200) {
        setOpenEditPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <EditStatusComponent
          gridData={gridData}
          statusList={statusList}
          patchLoading={patchLoading}
          handleStatusInclude={handleStatusInclude}
          setSelectedItem={setSelectedItem}
          setOpenEditPopup={setOpenEditPopup}
          openEditPopup={openEditPopup}
          handleEditStatusChange={handleEditStatusChange}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          handleOpenEditPopup={handleOpenEditPopup}
        />
      )}
    </>
  );
};
export default VehicleManifestStatusEdit;
